<template>
  <div>
    <v-btn
      v-if="context.request.user.is_authenticated"
      small
      elevation="0"
      color="bg-primary"
      :href="authenticatedData.href"
    >
      <v-icon
        color="primary"
        class="mr-2"
        size="20"
      >
        {{ authenticatedData.icon }}
      </v-icon>
      <span class="primary--text">
        {{ translate('Личный кабинет') }}
      </span>
    </v-btn>
    <v-menu
      v-else
      v-model="isActiveLogin"
      left
      bottom
      offset-y
      max-width="300"
      nudge-bottom="16"
      :close-on-content-click="false"
    >
      <template
        #activator="{ on, attrs }"
      >
        <v-btn
          small
          color="bg-primary"
          elevation="0"
          v-bind="attrs"
          v-on="on"
        >
          <div class="primary--text">
            {{ translate('Войти') }}
          </div>
        </v-btn>
      </template>
      <v-sheet
        class="pa-4"
      >
        <div>
          <div class="text-subtitle-1 text--text mb-2">
            {{ translate('Пациент') }}
          </div>
          <div class="text-caption text-secondary--text mb-2">
            {{ translate('Делитесь отзывами о врачах, записывайтесь на приём онлайн, ведите электронную медкарту') }}
          </div>
          <v-btn
            small
            elevation="0"
            color="primary"
            :href="patientAuthPath"
          >
            {{ translate('Войти') }}
          </v-btn>
        </div>
        <v-divider class="my-4" />
        <div>
          <div class="text-subtitle-1 text--text mb-2">
            {{ translate('Врач или клиника') }}
          </div>
          <div class="text-caption text-secondary--text mb-2">
            {{ translate('Отвечайте на отзывы пациентов, включайте запись на приём, рассказывайте о ваших услугах') }}
          </div>
          <v-btn
            small
            elevation="0"
            color="primary"
            :href="profileAuthPath"
          >
            {{ translate('Войти') }}
          </v-btn>
        </div>
      </v-sheet>
    </v-menu>
  </div>
</template>

<script setup lang="ts">
import { computed, ref, ComputedRef } from 'vue'
import type { ContextStore } from 'src/layouts/core-layout/types'
import { useContextStore, useURLStore } from 'src/store'
import useAuthLinks from 'src/layouts/core-layout/components/CoreHeader/components/mobile/composables/useAuthLinks'
import { translate } from 'src/layouts/core-layout/_functions/translate'

const { context }: ContextStore = useContextStore()
const { reverseFull } = useURLStore()
const isActiveLogin = ref(false)
const { siteNamePD } = context.global.sites
const { patientAuthPath, profileAuthPath } = useAuthLinks()

const authenticatedData: ComputedRef<{ href: string, icon: string }> = computed(() => {
  if (!context.is_fake_user) {
    if (context.request.user.patient_profile) {
      return {
        href: reverseFull({ name: 'medtochka:redirect_to_medtochka' }),
        icon: 'ui-icon-user-only',
      }
    }

    if (context.request.user.is_staff) {
      return {
        href: new URL('profile/', siteNamePD).href,
        icon: 'ui-icon-user-only',
      }
    }

    if (context.request.user.user2.is_doctor) {
      return {
        href: new URL('profile/doctors/', siteNamePD).href,
        icon: 'ui-icon-doctor',
      }
    }

    if (context.request.user.user2.is_lpu) {
      return {
        href: new URL('profile/lpus/', siteNamePD).href,
        icon: 'ui-icon-doctor',
      }
    }
  }

  if (context.lpu.owner && context.request.path.includes('/lpu/')) {
    const url = new URL('profile/lpus/', siteNamePD)

    url.searchParams.set('lpu', String(context.lpu.id))

    return {
      href: url.href,
      icon: 'ui-icon-doctor',
    }
  }

  if (context.lpu && !context.lpu.owner && context.request.path.includes('/lpu/')) {
    const url = new URL('cabinet/', siteNamePD)

    url.searchParams.set('lpu', String(context.lpu.id))

    return {
      href: url.href,
      icon: 'ui-icon-doctor',
    }
  }

  if (context.doctor.owner && context.request.path.includes('/vrach/')) {
    const url = new URL('profile/doctors/', siteNamePD)

    url.searchParams.set('doctor', String(context.doctor.id))

    return {
      href: url.href,
      icon: 'ui-icon-doctor',
    }
  }

  return {
    href: '',
    icon: '',
  }
})
</script>
